import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lwf-form',
  templateUrl: './lwf-form.component.html',
  styleUrls: ['./lwf-form.component.css']
})
export class LwfFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/lwf/lwf-form/lwf-form.component.ts